import { S3Client, GetObjectCommand, PutObjectCommand } from "@aws-sdk/client-s3";
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers";

const REGION = process.env.REACT_APP_AWS_REGION || "us-east-2";
const BUCKET = "mitchellcampbellwebsite";
const PREFIX = "data_in/";
const CACHE_PREFIX = "mc_";

const s3 = new S3Client({
  region: REGION,
  credentials: fromCognitoIdentityPool({
    clientConfig: { region: REGION },
    identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
  }),
});

function cacheKey(filename) { return CACHE_PREFIX + filename; }

export function getCachedJson(filename, fallback = null) {
  try {
    const raw = localStorage.getItem(cacheKey(filename));
    return raw ? JSON.parse(raw) : fallback;
  } catch { return fallback; }
}

function setCache(filename, data) {
  try { localStorage.setItem(cacheKey(filename), JSON.stringify(data)); } catch {}
}

export async function fetchJson(filename, fallback = null) {
  try {
    const res = await s3.send(new GetObjectCommand({
      Bucket: BUCKET,
      Key: `${PREFIX}${filename}`,
    }));
    const text = await res.Body.transformToString();
    const data = JSON.parse(text);
    setCache(filename, data);
    return data;
  } catch (e) {
    if (e.name === "NoSuchKey" || e.$metadata?.httpStatusCode === 404) return fallback;
    throw e;
  }
}

export async function saveJson(filename, data) {
  setCache(filename, data);
  await s3.send(new PutObjectCommand({
    Bucket: BUCKET,
    Key: `${PREFIX}${filename}`,
    Body: JSON.stringify(data),
    ContentType: "application/json",
  }));
}
